/**
 * 会員セッションの問い合わせ（M6a の `/auth/session`）。
 *
 * ログイン状態はユーザーデータ層（EP-1 個人データ）と公開コメント（EP-1 公開データ）の
 * 両方が要るため、1 つのインスタンスを共有して**起動時に 1 度だけ**問い合わせる。
 * 失敗（非 ok・例外）はすべて「未ログイン」に倒す — 読書を止めないため。
 */

/** 現在の閲覧者（表示名は導入側が渡したときだけ入る）。 */
export interface SessionUser {
  id: string;
  name: string | null;
}

export class Session {
  private pending: Promise<SessionUser | null> | null = null;

  constructor(private readonly base: string) {}

  /** 現在の閲覧者（未ログインなら null）。何度呼んでも要求は 1 度きり。 */
  user(): Promise<SessionUser | null> {
    return (this.pending ??= this.fetchUser());
  }

  private async fetchUser(): Promise<SessionUser | null> {
    try {
      const response = await fetch(this.base + '/auth/session', { credentials: 'same-origin' });
      if (!response.ok) return null;
      const data = (await response.json()) as { user?: { id?: string; name?: string } | null };
      const id = data.user?.id;
      if (typeof id !== 'string') return null;
      return { id, name: typeof data.user?.name === 'string' ? data.user.name : null };
    } catch {
      return null;
    }
  }
}
